import React from 'react';
import './App.css';

import Pruebas from './Components/Pruebas'

function App() {
  return (
    <div className="App">
                                                              
      <Pruebas />

    </div>
  );
}

export default App;
